import { render, staticRenderFns } from "./PredictionCurve.vue?vue&type=template&id=4d7e4c2a&scoped=true"
import script from "./PredictionCurve.vue?vue&type=script&lang=js"
export * from "./PredictionCurve.vue?vue&type=script&lang=js"
import style0 from "./PredictionCurve.vue?vue&type=style&index=0&id=4d7e4c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7e4c2a",
  null
  
)

export default component.exports